<template>
    <ui-dropdown placement="bottom-start" :menu-class="menuClass" trigger-class="flex-1" :enabled="enabled"
                 ref="dropdown">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 w-full max-w-full flex border-b border-gray-300 flex">
                <div class="flex-grow w-full">
                    <div class="mb-1 w-full">
                        <div
                            class="flex w-full text-sm font-medium text-blue-600 mb-1 pb-1 border-b border-gray-300">
                            <div class="ml-2 flex-grow">
                                <div
                                    @click="(current && !current.isDelivery)?$emit('toggleCollection',true):false"
                                    class="inline-block mr-2 pr-2 border-brand cursor-pointer border-r"
                                    :class="(!current || current.isDelivery)?'font-bold':'hover:underline'">Delivery
                                </div>
                                <div
                                    @click="(!current || current.isDelivery)?$emit('toggleCollection',false):false"
                                    class="inline-block cursor-pointer hover:underline"
                                    :class="(current && !current.isDelivery)?'font-bold':'hover:underline'">Collection
                                </div>
                            </div>
                        </div>
                        <div v-if="addresses.length > 0" class="space-y-1">
                            <div
                                v-for="(addressData,index) in addresses"
                                class="flex packageItems-center space-x-2 text-left w-full rounded-md px-1 py-0 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="addressData.address"
                            >
                                <div class="flex-1 flex flex-col" v-if="editing !== index">
                                    <div
                                        class="flex border border-transparent rounded-lg text-xs text-left font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-0 focus:ring-blue-500 hover:text-gray-600">
                                        <div class="flex-grow flex mx-0 p0-5">
                                            <div class="flex flex-1 w-[128px] overflow-x-scroll overflow-y-hidden">
                                                <button
                                                    @mousedown="selectExistingItem(addressData, close)"
                                                    class="flex w-full items-start flex-col px-2 py-1 -my-0.5"
                                                >
                                                    <div
                                                        class="flex-1 flex-grow mr-1 relative whitespace-nowrap"
                                                        v-text="addressData.address.replace(/\n/g, ', ') ?addressData.address.replace(/\n/g, ', '):'<blank address lines>'">
                                                    </div>
                                                    <div
                                                        class="flex-1 mr-1 relative truncate whitespace-nowrap text-gray-400 min-h-3"
                                                        v-text="addressData.contactName+
                                                        (addressData.contactNumber ? ' - ' + addressData.contactNumber : '')">
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="flex-shrink flex items-center justify-center mr-2">
                                            <div class="fa fa-edit text-base text-gray-300 hover:text-blue-500"
                                                 @click="edit(index)"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else
                                     class="text-gray-600 flex-1 px-3 mb-2 mt-1 pb-1 pt-2 border-t border-gray-300">
                                    <div class="m-0 flex flex-1 p-0 pb-1">
                                        <label class="flex-1 flex-grow m-0 pt-1.5">Edit address:</label>
                                        <ui-button-new small v-if="packageReference"
                                                       @click="loadSiteAddress(editAddressData)">Use Site Address
                                        </ui-button-new>
                                    </div>
                                    <textarea-autosize
                                        class="rounded-md border border-gray-300 text-sm mt-0 mb-1 px-1 py-1"
                                        v-model="editAddressData.address" rows="3" ref="editAddress"
                                    >
                                    </textarea-autosize>
                                    <div class="flex pt-1">
                                        <div class="flex-1 mr-1">
                                            <label>Contact Name:</label>
                                            <input class="rounded-md border border-gray-300 text-sm m-0"
                                                   style="margin-bottom: 0px !important;"
                                                   v-model="editAddressData.contactName"/>
                                        </div>
                                        <div class="flex-1 ml-1">
                                            <label>Contact Phone:</label>
                                            <input class="rounded-md border border-gray-300 text-sm m-0"
                                                   style="margin-bottom: 0px !important;"
                                                   @keyup.enter="applyEditingAddress(close)"
                                                   v-model="editAddressData.contactNumber"/>
                                        </div>
                                    </div>
                                    <div class="flex pt-2 justify-center">
                                        <div class="flex-shrink">
                                            <ui-button-new small
                                                           extra icon="fa fa-plus"
                                                           @click="applyEditingAddress(close)">Apply
                                            </ui-button-new>
                                        </div>
                                        <div class="ml-2 flex-shrink">
                                            <ui-button-new small
                                                           danger icon="fa fa-times"
                                                           @click="cancelEditingAddress">Cancel
                                            </ui-button-new>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="!addingAddress" class="text-gray-500 text-sm">
                            <div class="mb-1 p-2">No addresses in use</div>
                        </div>
                        <div v-if="addingAddress"
                             class="text-gray-600 px-3 mb-2 mt-1 pb-1 pt-2 border-t border-gray-300">
                            <div class="m-0 flex flex-1 p-0 pb-1">
                                <label class="flex-1 flex-grow m-0 pt-1.5">New address:</label>
                                <ui-button-new small v-if="packageReference"
                                               @click="loadSiteAddress(addressData)">Use Site Address
                                </ui-button-new>
                            </div>
                            <textarea-autosize class="rounded-md border border-gray-300 text-sm mt-0 mb-1 px-1 py-1"
                                               v-model="addressData.address" rows="3" ref="address"
                            >
                            </textarea-autosize>
                            <div class="flex pt-1">
                                <div class="flex-1 mr-1">
                                    <label>Contact Name:</label>
                                    <input class="rounded-md border border-gray-300 text-sm m-0"
                                           style="margin-bottom: 0px !important;"
                                           v-model="addressData.contactName"/>
                                </div>
                                <div class="flex-1 ml-1">
                                    <label>Contact Phone:</label>
                                    <input class="rounded-md border border-gray-300 text-sm m-0"
                                           style="margin-bottom: 0px !important;"
                                           @keyup.enter="applyNewAddress(close)"
                                           v-model="addressData.contactNumber"/>
                                </div>
                            </div>
                            <div class="flex pt-2 justify-center">
                                <div class="flex-shrink">
                                    <ui-button-new small
                                                   extra icon="fa fa-plus"
                                                   @click="applyNewAddress(close)">Apply
                                    </ui-button-new>
                                </div>
                                <div class="ml-2 flex-shrink">
                                    <ui-button-new small
                                                   danger icon="fa fa-times"
                                                   @click="cancelNewAddress">Cancel
                                    </ui-button-new>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex border-t border-gray-300 pt-3">
                        <div class="flex-grow">
                            <ui-button-new small extra icon="fa fa-plus" @click="addAddress(close)"
                                           v-if="!addingAddress && (editing === false)">
                                Add a new Address/Contact
                            </ui-button-new>
                        </div>
                        <div class="flex-shrink" v-if="current">
                            <ui-button-new small danger icon="fa fa-trash" @click="clearAddress(close)">
                                Clear delivery data
                            </ui-button-new>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>

import UiInput from "../../ui/UiInput.vue";
import UiDatePicker from "../../ui/UiDatePicker.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import {cloneDeep} from "lodash";
import {PackageNew} from "@models";

export default {
    components: {UiButtonNew, UiDatePicker, UiInput},
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
        menuClass: {
            type: String,
            default: 'w-full',
        },
        packageReference: null,
        current: null,
        addresses: Array,
        enabled: true,
    },
    data() {
        return {
            addingAddress: false,
            editing: false,
            addressData: {},
            editAddressData: {},
        }
    },
    computed: {},
    methods: {
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        selectExistingItem(addressData, close) {
            this.addingAddress = false
            this.$emit('selected:existingAddress', {addressData});
            close();
        },
        edit(index) {
            this.editing = index;
            this.editAddressData = cloneDeep(this.addresses[index])
            this.$nextTick(() => {
                this.$refs.editAddress[0].$el.focus();
            })
        },
        addAddress() {
            this.addressData = {address: '', contactName: '', contactPhone: ''}
            this.addingAddress = true
        },
        applyEditingAddress() {
            this.$emit('updateAddresses', this.addresses[this.editing].items, this.editAddressData);
            Object.assign(this.addresses[this.editing], this.editAddressData)
            this.editing = false
        },
        cancelEditingAddress() {
            this.editing = false
        },
        applyNewAddress(close) {
            this.$emit('addAddress', {addressData: this.addressData});
            this.addingAddress = false
            close();
        },
        cancelNewAddress() {
            this.addingAddress = false
        },
        clearAddress(close) {
            this.addingAddress = false;
            this.$emit('clearAddress');
            close()
        },
        close() {
            this.addingAddress = false;
            this.$refs.dropdown.close();
        },
        async loadSiteAddress(into) {
            let p = await PackageNew.find(this.packageReference);
            into.address = p.address
        }
    },
    mounted() {
    },
    beforeDestroy() {
        this.$refs.dropdown.close();
    }
}
</script>
